import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CloseRounded } from "@mui/icons-material";
import { Avatar, Dialog, DialogContent, Grid, TextField } from "@mui/material";
import { api_urls } from "../../../utils/api-urls/index.js";
import * as EcommerceActions from '../../../redux/actions/ecommerceAction.js';
import MainDatatable from "../../../components/common/MainDatatable.jsx";
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { DeleteSvg, EditSvg, FilterSvg, SwitchOffSvg, SwitchOnSvg, UploadImageSvg, ViewSvg } from "../../../assets/svg/index.js";

const DisplayCategory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ecommerceCategoryData } = useSelector(state => state.ecommerceReducer);

  const [modalVisible, setModalVisible] = useState(false);
  const [categoryDetail, setCategoryDetail] = useState({ categoryId: '', categoryName: '', tax: '' });
  const [inputFieldError, setInputFieldError] = useState({ categoryName: '', tax: '', image: '' });
  const [image, setImage] = useState({ file: '', bytes: '' });

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setCategoryDetail({ ...categoryDetail, [name]: value });
  };

  //! Handle Image : Normally
  const handleImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
    }

    handleInputFieldError("image", null)
  };

  //! Handle Image : Drop Feature
  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setImage({
        file: URL.createObjectURL(e.dataTransfer.files[0]),
        bytes: e.dataTransfer.files[0],
      });
    }

    handleInputFieldError("image", null)
  };

  //! Handle Edit - Category
  const handleEdit = (data) => {
    setModalVisible(!modalVisible)
    console.log("Edit Data ::: ", data)

    setCategoryDetail({
      categoryId: data?._id || '',
      categoryName: data?.title || '',
      tax: data?.tax || '',
    });
    setImage({ file: api_urls + data?.image })
  }

  //! Handle validation
  const handleValidation = () => {
    let isValid = true;
    const { categoryName, tax } = categoryDetail;

    if (!categoryName) {
      handleInputFieldError("categoryName", "Please Enter Category Name")
      isValid = false;
    }
    if (!tax) {
      handleInputFieldError("tax", "Please Enter Tax")
      isValid = false;
    }

    return isValid;
  };

  //! Handle Submit - Updating Category
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      console.log("Category Data :: ", { ...categoryDetail, image })
      const { categoryId, categoryName, tax } = categoryDetail;

      let formData = new FormData()
      formData.append("productCategoryId", categoryId)
      formData.append("title", categoryName)
      formData.append("tax", tax)
      formData.append("image", image?.bytes);

      const payload = {
        data: formData,
        onComplete: () => setModalVisible(false)
      }

      //! Dispatching API for Updating Category
      dispatch(EcommerceActions.updateEcommerceCategory(payload))
    }
  };

  //* Category DataTable Columns
  const categoryColumns = [
    { name: 'S.No.', selector: row => ecommerceCategoryData.length - ecommerceCategoryData.indexOf(row), style: { backGroundColor: "#000", paddingLeft: "20px" } },
    { name: 'Title', selector: row => row?.title },
    { name: 'Tax', selector: row => row?.tax },
    { name: 'Image', cell: row => <img src={row?.image ? api_urls + row?.image : logo_icon} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
    { name: 'Status', selector: row => <div onClick={() => dispatch(EcommerceActions?.changeEcommerceCategoryStatus({ productCategoryId: row?._id }))} style={{ cursor: "pointer" }}>{row?.status == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div> },
    {
      name: 'Action',
      cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
        <div onClick={() => navigate(`/e-commerce/category/${row?._id}`)} style={{ cursor: "pointer" }}><ViewSvg /></div>
        <div onClick={() => handleEdit(row)} style={{ cursor: "pointer" }}><EditSvg /></div>
        <div onClick={() => dispatch(EcommerceActions.deleteEcommerceCategory({ productCategoryId: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
      </div >,
      width: "180px"
    },
  ]

  useEffect(() => {
    //! Dispatching API for Getting Category
    dispatch(EcommerceActions.getEcommerceCategory())
  }, []);

  return (
    <>
      <MainDatatable data={ecommerceCategoryData} columns={categoryColumns} title={'Ecommerce Category'} url={'/e-commerce/add-category'} />

      <Dialog
        open={modalVisible}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12} md={12} xs={12} sx={{ marginBottom: "20px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ fontSize: "23px", fontWeight: "600" }}>Edit Ecommerce Category</div>
                <div onClick={() => setModalVisible(false)}><CloseRounded /></div>
              </div>
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12} >
              <div style={{ color: "#000", border: "1px solid #C4C4C4", borderRadius: "3px" }}>
                {image?.file || image?.bytes ?
                  <label onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} htmlFor="upload-image" style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px", cursor: "pointer" }}>
                    <Avatar src={image.file} style={{ height: '220px', width: "220px", borderRadius: "initial" }} />
                  </label>
                  :
                  <label onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} htmlFor="upload-image" style={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center", padding: "50px 0", cursor: "pointer" }}>
                    <UploadImageSvg h="80" w="80" color="#C4C4C4" />
                    <div style={{ fontWeight: "600", fontSize: "18px" }}>Choose Your Image to Upload</div>
                    <div style={{ fontWeight: "500", fontSize: "16px", color: 'grey' }}>Or Drop Your Image Here</div>
                  </label>}
                <input id="upload-image" onChange={handleImage} hidden accept="image/*" type="file" />
              </div>
              {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10.75px", padding: "10px 0 0 12px", }}>{inputFieldError?.image}</div>}
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <TextField
                label="Title" variant='outlined' fullWidth
                name='categoryName'
                value={categoryDetail?.categoryName}
                onChange={handleInputField}
                error={inputFieldError.categoryName ? true : false}
                helperText={inputFieldError.categoryName}
                onFocus={() => handleInputFieldError("categoryName", null)}
              />
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <TextField
                label="Tax (%)" type="number" variant='outlined' fullWidth
                name='tax'
                value={categoryDetail?.tax}
                onChange={handleInputField}
                error={inputFieldError.tax ? true : false}
                helperText={inputFieldError.tax}
                onFocus={() => handleInputFieldError("tax", null)}
              />
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12} sx={{ marginTop: "15px" }}>
              <Grid container spacing={2}>
                <Grid item lg={6} sm={6} md={6} xs={6} >
                  <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px", textAlign: "center", fontFamily: "Philosopher" }}>Submit</div>
                </Grid>
                <Grid item lg={6} sm={6} md={6} xs={6} >
                  <div onClick={() => setModalVisible(false)} style={{ fontWeight: "500", backgroundColor: "#EDF2F5", color: "#000", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px", textAlign: "center", fontFamily: "Philosopher" }}>
                    Close
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </ >
  );
}

export default DisplayCategory;